import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addUpcomingEvent } from "../../Adapters/ApiAdapter";
import { baseUrl } from "../../variables/Variables";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import SeoTags from "../SeoTags/SeoTags";
import CKEditorField from "../../components/CKEditorField";

const AddUpcomingEvent = () => {
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    event_type: "",
    start_event_date: "",
    end_event_date: "",
    heading: "",
    description: "",
    main_img_path: null,
    additional_images: null,
    location: "",
    banner_img: null,
    seo_title: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    custom_scripts: "",
    og_title: "",
    og_description: "",
    og_type: "",
    og_url: "",
    og_image: "",
    og_locale: "",
    og_site_name: "",
    og_image_width: "",
    og_image_height: "",
    og_image_type: "",
    article_modified_time: "",
    canonical_link: "",
    twitter_card: "",
    twitter_site: "",
    twitter_title: "",
    twitter_description: "",
    twitter_image: "",
  });
  const [loading, setLoading] = useState(false);
  const [mainImgPath, setMainImgPath] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [bannerImg, setBannerImg] = useState(null);
  const [ogImage, setOgImage] = useState(null);
  const [loadingAction, setLoadingAction] = useState(false);
  const navigate = useNavigate();


  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      let updatedForm = { ...prev, [name]: value };

      if (name === "name") {
        updatedForm.slug = generateSlug(value);
      }

      return updatedForm;
    });
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  // const handleFileChange = (e) => {
  //   setFormData({ ...formData, img_path: e.target.files[0] });
  // };
  const handleFileChange = (e, key, setPreviewState) => {
    const file = e.target.files[0];
    if (file) {
      const timestamp = Date.now();
      const renamedFile = new File([file], `${timestamp}-${file.name}`, {
        type: file.type,
      });

      if (setPreviewState) {
        setPreviewState(URL.createObjectURL(renamedFile));
      }

      setFormData((prev) => ({
        ...prev,
        [key]: renamedFile,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // here we check the end date should not be less than/before the start date
    if (
      new Date(formData.end_event_date) < new Date(formData.start_event_date)
    ) {
      toast.error("End date cannot be before the start date.");
      setLoadingAction(false);
      return;
    }

    const eventData = new FormData();
    // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();
    // const stripHtml = (html) =>
    //   html ? html.replace(/<[^>]+>/g, "").trim() : "";
    eventData.append("name", formData.name);
    eventData.append("slug", formData.slug);
    eventData.append("event_type", formData.event_type);
    eventData.append("start_event_date", formData.start_event_date);
    eventData.append("end_event_date", formData.end_event_date);
    eventData.append("heading", formData.heading);
    eventData.append("description", formData.description);
    eventData.append("seo_title", formData.seo_title);
    eventData.append("meta_title", formData.meta_title);
    eventData.append("meta_description", formData.meta_description);
    eventData.append("meta_keywords", formData.meta_keywords);
    eventData.append("custom_scripts", formData.custom_scripts);
    eventData.append("og_title", formData.og_title);
    eventData.append("og_description", formData.og_description);
    eventData.append("og_type", formData.og_type);
    eventData.append("og_url", formData.og_url);
    eventData.append("og_locale", formData.og_locale);
    eventData.append("og_site_name", formData.og_site_name);
    eventData.append("og_image_width", formData.og_image_width);
    eventData.append("og_image_height", formData.og_image_height);
    eventData.append("og_image_type", formData.og_image_type);
    eventData.append("article_modified_time", formData.article_modified_time);
    eventData.append("canonical_link", formData.canonical_link);
    eventData.append("twitter_card", formData.twitter_card);
    eventData.append("twitter_site", formData.twitter_site);
    eventData.append("twitter_title", formData.twitter_title);
    eventData.append("twitter_description", formData.twitter_description);
    eventData.append("location", formData.location);

    if (formData.main_img_path) {
      eventData.append("main_img_path", formData.main_img_path);
    }
    // if (formData.additional_images) {
    //   eventData.append("additional_images", formData.additional_images);
    // }
    if (Array.isArray(formData.additional_images)) {
      formData.additional_images.forEach((file, index) => {
        eventData.append(`additional_images[]`, file); // append as array
      });
    }
    if (formData.banner_img) {
      eventData.append("banner_img", formData.banner_img);
    }

    if (formData.og_image instanceof File) {
      eventData.append("og_image", formData.og_image);
    }
    // if (formData.og_image) {
    //   eventData.append("og_image", formData.og_image);
    // }
    if (formData.twitter_image) {
      eventData.append("twitter_image", formData.twitter_image);
    }

    try {
      const response = await addUpcomingEvent(eventData);
      console.log("Here is Add job: ", response);
      if (response.status === "true" || response.status === true) {
        toast.success("Event added successfully!");
        setTimeout(() => {
          navigate("/upcoming-event-list");
        }, 1500);
      } else {
        toast.error("Failed to add event.");
      }
    } catch (error) {
      toast.error("An error occurred while adding the event.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Upcoming Event
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          name="Slug"
          label="slug"
          value={formData.slug}
          onChange={handleInputChange}
        />

        <FormControl fullWidth margin="normal" required>
          <InputLabel id="event-type-label">Event Type</InputLabel>
          <Select
            labelId="event-type-label"
            name="event_type"
            value={formData.event_type}
            onChange={handleInputChange}
          >
            <MenuItem value="CME">CME</MenuItem>
            <MenuItem value="Camps">Camps</MenuItem>
            <MenuItem value="Others">Others</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Start Event Date"
          name="start_event_date"
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          value={formData.start_event_date}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="End Event Date"
          name="end_event_date"
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          value={formData.end_event_date}
          onChange={handleInputChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Heading"
          name="heading"
          value={formData.heading}
          onChange={handleInputChange}
          required
        />

        <Typography variant="body1" mt={2}>
          Description
        </Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.description}
          onChange={(value) => setFormData({ ...formData, description: value })}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.description}
            onChange={(data) => setFormData((prev) => ({ ...prev, description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=events`}
          />

        <TextField
          fullWidth
          margin="normal"
          label="Location"
          name="location"
          value={formData.location}
          onChange={handleInputChange}
          required
        />
        <SeoTags formData={formData} setFormData={setFormData} />
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: "16px" }}
        >
          Upload Main Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) =>
              handleFileChange(e, "main_img_path", setMainImgPath)
            }
          />
        </Button>
        {formData.main_img_path && (
          <Typography variant="body2" style={{ marginTop: "8px" }}>
            Selected File: {formData.main_img_path.name}
          </Typography>
        )}

        {/* <Box mt={2}>
          <Button
            variant="contained"
            component="label"
            style={{ marginTop: "16px" }}
          >
            Upload Additional Images
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                handleFileChange(e, "additional_images", setAdditionalImages)
              }
            />
          </Button>
          {formData.additional_images && (
            <Typography variant="body2" style={{ marginTop: "8px" }}>
              Selected File: {formData.additional_images.name}
            </Typography>
          )}
        </Box> */}
        <Box mt={2}>
          <Button variant="contained" component="label">
            Upload Additional Images
            <input
              type="file"
              accept="image/*"
              hidden
              multiple
              onChange={(e) => {
                const files = Array.from(e.target.files).map((file) => {
                  const timestamp = Date.now();
                  return new File([file], `${timestamp}-${file.name}`, {
                    type: file.type,
                  });
                });
                setAdditionalImages(files);
                setFormData((prev) => ({
                  ...prev,
                  additional_images: files,
                }));
              }}
            />
          </Button>

          {additionalImages?.length > 0 && (
            <Box mt={1} display="flex" flexWrap="wrap" gap={2}>
              {additionalImages.map((file, index) => (
                <img
                  key={index}
                  src={URL.createObjectURL(file)}
                  alt={`preview-${index}`}
                  style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8 }}
                />
              ))}
            </Box>
          )}
        </Box>
        <Box mt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            style={{ marginTop: "20px" }}
          >
            {loading ? <CircularProgress size={24} /> : "Add Event"}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddUpcomingEvent;
